import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import themeUtilities from '../../../theme/ThemeUtilities';
import { TagInputSize, TagInputStatus } from './types';

export const InputWrapper = styled.div<{
  size: TagInputSize;
  status: TagInputStatus;
  fullWidth: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  transition: border-color 250ms ease-in-out;
  will-change: border-color;
  box-sizing: border-box;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `};

  ${(props) =>
    variant(themeUtilities.getComponentVariant(props, 'TagInput', 'size'))};
  ${(props) =>
    variant(themeUtilities.getComponentVariant(props, 'TagInput', 'status'))};
`;

export const Input = styled.input<{ inputSize: TagInputSize }>`
  border: none;
  outline: none;
  background: none;
  ${(props) =>
    variant(
      themeUtilities.getComponentVariant(props, 'TagInput', 'inputSize')
    )};
`;
